import FutuCandleWS from './futuCandlews'

class FutuCandleWSManager {
    private static instance: FutuCandleWSManager
    private socketMap: Map<string, FutuCandleWS> = new Map()

    private constructor() { }

    // 싱글턴 인스턴스 반환
    public static getInstance(): FutuCandleWSManager {
        if (!FutuCandleWSManager.instance) {
            FutuCandleWSManager.instance = new FutuCandleWSManager()
        }
        return FutuCandleWSManager.instance
    }

    // 웹소켓 추가 및 관리
    public addSocket(coinID: string, chartINT: string): FutuCandleWS {
        const key = `${coinID.toLowerCase()}_${chartINT}`

        // 기존 웹소켓이 있으면 반환
        if (this.socketMap.has(key)) {
            return this.socketMap.get(key)!
        }

        // 새로운 웹소켓 생성
        const newSocket = new FutuCandleWS()
        newSocket.Init(coinID, chartINT)

        this.socketMap.set(key, newSocket)
        return newSocket
    }

    // 특정 웹소켓 제거
    public removeSocket(coinID: string, chartINT: string, subscriberUID = ''): void {
        const key = subscriberUID ? subscriberUID : `${coinID.toLowerCase()}_${chartINT}`
        const socket = this.socketMap.get(key)

        if (socket) {
            socket.stop()
            socket.close()
            this.socketMap.delete(key)
        }
    }

    // 모든 웹소켓 종료 및 초기화
    public clearAllSockets(): void {
        this.socketMap.forEach((socket) => {
            socket.stop()
            socket.close()
        })
        this.socketMap.clear()
    }

    // 웹소켓 리턴
    public getSocket() {
        return this.socketMap
    }
}

export default FutuCandleWSManager
